// src/analytics/usePageTracking.js
import { useEffect } from "react";
import { useLocation } from "react-router";
import { trackPageView } from "./ga";

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    trackPageView(path);
  }, [location]);
}
